import type { ReactElement } from 'react'
import LoadingSpinner from '@/components/ui/loading-spinner'
import { Skeleton } from '@/components/ui/skeleton'

export const STRIPE_CONNECT_NOTIFICATION_BANNER_MIN_HEIGHT_CLASS = 'min-h-[80px]'

export default function StripeConnectNotificationBannerPlaceholder(): ReactElement {
  return (
    <div className="pointer-events-none flex h-full w-full items-center">
      <div className="w-full rounded-md border border-border bg-card px-4 py-3">
        <div className="flex w-full items-start gap-3">
          <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border/70 bg-card/95 text-interaction">
            <LoadingSpinner className="h-3.5 w-3.5" />
          </div>

          <div className="min-w-0 flex-1 space-y-2.5">
            <Skeleton tone="neutral" className="h-3.5 w-52 max-w-full rounded-full" />
            <Skeleton tone="neutral" className="h-2.5 w-4/5 max-w-full rounded-full" />
          </div>

          <Skeleton tone="neutral" className="hidden h-8 w-24 shrink-0 rounded-full sm:block" />
        </div>
      </div>
    </div>
  )
}
